<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
            <ion-menu-button v-if="rightToAdd"></ion-menu-button>
            <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
            <ion-title>Charger Installations List</ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
            <ion-button @click="addChargerInstall" v-if="rightToAdd" class="hdrBtn">
                <ion-icon v-slot: start :icon="add"></ion-icon>&nbsp;New Charger Installation
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ChargerInstallations />
        </ion-content>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerInstallations from "@/components/admin/ChargerInstallations.vue";
import { AppUtils } from "@/util/app-utils";
import { add } from 'ionicons/icons';
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'chargerInstallations',
    components: {
        ChargerInstallations, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonBackButton, IonTitle, IonButton, IonIcon, IonContent
    },
    data() {
        return {
            add,
            rightToAdd: false
        }
    },
    mounted() {
        this.rightToAdd = new AppUtils().getUserAccess("40|C");
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        addChargerInstall() {
        localStorage.removeItem("bayStationInfo")
        this.$router.push("/admin/chargerinstallations/bay");
        },
    }
})
</script>
